import React, { useState } from "react";

import { Backdrop, Box, CircularProgress, Fade, Grid, IconButton, Modal } from "@mui/material";
import {
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon,
} from "@mui/icons-material";
import { Document, Page } from "react-pdf";

import useStyles from "./styles";

interface Props {
  url?: string;
  open: boolean;
  handleClose: () => void;
}

const ShowPdfModal = (props: Props) => {
  const { open, url, handleClose } = props;

  const classes = useStyles();

  const [numPages, setNumPages] = useState<number>();
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const changePage = (offset: number) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  const onClose = () => {
    setNumPages(undefined);
    setPageNumber(1);
    handleClose();
  };

  const renderPdf = () => {
    if (url) {
      return (
        <Document
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          onItemClick={({ pageNumber }) => setPageNumber(Number(pageNumber) || 1)}
          className={classes.pdf}
          loading={<CircularProgress className={classes.loadingProgress} />}
        >
          <Page pageNumber={pageNumber} renderAnnotationLayer={false} renderTextLayer={false} />
        </Document>
      );
    }

    return <> </>;
  };

  const previousPageIsDisabled = pageNumber <= 1;
  const nextPageIsDisabled = numPages ? pageNumber >= numPages : true;

  const renderFooter = () => {
    if (numPages !== undefined) {
      return (
        <Grid
          className={classes.grid}
          direction="row"
          justifyContent="center"
          alignItems="center"
          container
        >
          <Grid item>
            <IconButton disabled={previousPageIsDisabled} onClick={previousPage}>
              <NavigateBeforeIcon
                style={{ opacity: previousPageIsDisabled ? 0.5 : 1 }}
                htmlColor="#FFFFFF"
              />
            </IconButton>
          </Grid>
          <Grid item>
            <span className={classes.textPages}>
              Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
            </span>
          </Grid>
          <Grid item>
            <IconButton disabled={nextPageIsDisabled} onClick={nextPage}>
              <NavigateNextIcon
                style={{ opacity: nextPageIsDisabled ? 0.5 : 1 }}
                htmlColor="#FFFFFF"
              />
            </IconButton>
          </Grid>
        </Grid>
      );
    }

    return null;
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box className={classes.box}>
          {renderPdf()}
          {renderFooter()}
        </Box>
      </Fade>
    </Modal>
  );
};

export default ShowPdfModal;
